import { initLocaleStore } from './i18n/locale-controller.js';
import { initProgression, getProgression } from './progression/context.js';
import { initAudioService } from './audio/context.js';
import './components/app-root.js';

async function bootstrap(): Promise<void> {
  await initProgression();
  const stored = getProgression().getLocale();
  initLocaleStore(stored ?? undefined);
  const audio = initAudioService();

  // Test-only: expose the audio service to E2E specs running with ?test-mute=1.
  // Production users cannot land on this branch unless they manually craft the URL,
  // and it only attaches a (muted) reference — no behavioural effect.
  if (
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).has('test-mute')
  ) {
    (window as unknown as { __audioService?: typeof audio }).__audioService = audio;
  }
}

void bootstrap();
